/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getClbTaskTemplateTable = params => {
  return axios.post(`${base}/query_tasktpl`, params)
}
export const createClbTaskTemplate = params => {
  params.json = JSON.stringify(params.json)
  return axios.post(`${base}/create_tasktpl`, params)
}
export const getClbTaskTemplate = params => {
  return axios.get(`${base}/tasktpl_` + params.id)
}
export const updateClbTaskTemplate = params => {
  params.json = JSON.stringify(params.json)
  return axios.post(`${base}/modify_tasktpl_` + params.id, params)
}
export const copyClbTaskTemplateTable = params => {
  return axios.post(`${base}/query_tasktpl`, params)
}
export const deleteClbTaskTemplateData = params => {
  return axios.post(`${base}/delete_tasktpl_` + params.id, params)
}
export const copyClbTaskTemplateData = params => {
  return axios.post(`${base}/copy_tasktpl_` + params.id, params)
}
export const showClbTaskTemplateData = params => {
  return axios.post(`${base}/show_tasktpl_${params.id}`, params)
}
export const hideClbTaskTemplateData = params => {
  return axios.post(`${base}/hide_tasktpl_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/clb-task-template/clb-task-template.api.js